<template>
    <div>
        <div v-loading="$parentInfo.schoolScore.dialog_AddSchoolScore.loading">
            <vue-scroll :ops="$ops">
                <el-form ref="form" :label-position="'center'"
                         :model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm"
                         label-width="80px"
                         style="max-height: calc(100vh - 125px)">
                    <el-row :gutter="20">
                        <!--学校选择-->
                        <el-col :span="13">
                            <el-form-item label="学校">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.school_name"
                                        :disabled=true class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="7">
                            <el-form-item label="年级">
                                <el-select
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.grade_id"
                                        filterable
                                        placeholder="请选择"
                                        @change="handleGetSchoolExam()"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.grades"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <!--考试选择-->
                        <el-col :span="13">
                            <el-form-item label="考试"
                                          v-if="$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                                <el-select
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_id"
                                        filterable
                                        placeholder="请选择"
                                        @change="handleGetSchoolExamSubjectScore()"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.schoolScore.dialog_AddSchoolScore.school_val.schoolExams"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-button @click="handleExamInputChange()" size="mini">+
                                    <!--<el-button @click="handleExamInputChange()" size="mini" v-if="powers.includes(33)">+-->
                                </el-button>
                            </el-form-item>

                            <el-form-item v-else label="考试">
                                <el-input style="width:215px"
                                          v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_name"
                                          placeholder="输入考试"
                                          class="inputWidth"></el-input>
                                <el-button @click="handleExamInputChange()" size="mini">-</el-button>
                            </el-form-item>
                        </el-col>

                        <el-col :span="7">
                            <el-form-item label="班级">
                                <el-select
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolClass_id"
                                        filterable placeholder="请选择"
                                        class="inputWidth">
                                    <el-option
                                            v-for="item in $parentInfo.initInformation.schoolClasses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10"
                                v-if="!$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                            <el-form-item label="考试时间" class="inputWidth">
                                <el-date-picker
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.examDate"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="7">
                            <el-form-item label="三总班级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.mainClassRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="三总年级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.mainGradeRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="三总地区排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.mainAreaRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="7">
                            <el-form-item label="全科班级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.sumClassRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="全科年级排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.sumGradeRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="全科地区排名" label-width="100px">
                                <el-input
                                        v-model="$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.sumAreaRank"
                                        placeholder="请输入班级排名"
                                        class="inputWidth"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!--v-if="$parentInfo.schoolScore.dialog_AddSchoolScore.subjectCheck ||  !$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status"  v-loading="$parentInfo.schoolScore.dialog_AddSchoolScore.loading"-->
                    <div>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>学科</th>
                                <th>学科总分</th>
                                <th>成绩</th>
                                <th>班级平均分</th>
                                <th>年级平均分</th>
                                <th>区平均分</th>
                                <th>班级排名</th>
                                <th>年级排名</th>
                                <th>区排名</th>
                                <th v-if="!$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                                    操作
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(formItem,index) in $parentInfo.schoolScore.dialog_AddSchoolScore.school_val.examSubjects"
                                :key="formItem.id">
                                <td v-if="$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                                    <el-input v-model="formItem.name" size="small" disabled></el-input>
                                </td>
                                <td v-else>
                                    <el-select v-model="formItem.subject_id" placeholder="请选择">
                                        <el-option
                                                v-for="item in $parentInfo.schoolScore.dialog_AddSchoolScore.subjects"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </td>
                                <td>
                                    <el-input disabled v-model="formItem.totalScore" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.score" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.classAvgScore" size="small"
                                              :disabled="$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.gradeAvgScore" size="small"
                                              :disabled="$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.areaAvgScore" size="small"
                                              :disabled="$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.classRank" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.gradeRank" size="small"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="formItem.areaRank" size="small"></el-input>
                                </td>
                                <td v-if="!$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                                    <el-button @click="handleDeleteExam(index)" size="mini">X</el-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <el-row :gutter="20"
                            v-if="!$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status">
                        <el-col :span="3" :offset=20 align="center">
                            <el-form-item>
                                <el-button @click="handleAddSubject()">新增学科</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </vue-scroll>
        </div>

        <div class="text-right">
            <el-button type="primary" size="small" @click="handleAddStudentScore()"
                       :loading="$parentInfo.schoolScore.dialog_AddSchoolScore.button_loading">保 存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_AddSchoolScore',
        data() {
            return {
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm = {
                schoolClass_id: '',
                grade_id: '',
                school_id: '',
                school_name: '',
                schoolExam_id: '',
                schoolExam_name: '',
                examDate: '',
                mainClassRank: '',
                sumClassRank: '',
                mainGradeRank: '',
                mainAreaRank: '',
                sumGradeRank: '',
                sumAreaRank: '',
            };
            this.handleShowStudentSchool();

            // this.handleSchoolClasses();
            // this.handleGetSchoolExam();
        },
        methods: {
            handleShowStudentSchool() {
                this.$wApi.send(this.$parentInfo.path, 'showStudentSchool', {
                    'student_id': this.$parentInfo.student_id
                });
            },
            // handleSchoolClasses() {
            //     this.$wApi.send(this.$parentInfo.path, 'schoolClasses');
            // },
            //考试学科获取
            handleGetSchoolExamSubjectScore() {
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.examSubjects = [];
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.loading = true;
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.subjectCheck = false;
                this.$wApi.send(this.$parentInfo.path, 'getSchoolExamSubjectScore', {
                    'schoolExam_id': this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_id,
                });
            },
            handleGetSchoolExam() {
                this.$wApi.send(this.$parentInfo.path, 'getSchoolExam', {
                    'school_id': this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.school_id,
                    'grade_id': this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.grade_id,
                });
            },
            //添加学生学校成绩
            handleAddStudentScore() {
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'addStudentScore', {
                    'student_id': this.$parentInfo.student_id,
                    'grade_id': this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.grade_id,
                    'examSubjects': this.$parentInfo.schoolScore.dialog_AddSchoolScore.school_val.examSubjects,
                    'outlineForm': this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm,
                    'exam_status': this.$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status,
                });
            },
            handleExamInputChange() {
                if (this.$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status === true) {
                    this.$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status = false;
                } else {
                    this.$parentInfo.schoolScore.dialog_AddSchoolScore.exam_status = true;
                }
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.school_val.examSubjects = [];
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_id = '';
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.outlineForm.schoolExam_name = '';
            },
            handleAddSubject() {
                let examSubject = {
                    id: 0,
                    subject_id: '',
                    name: '',
                    totalScore: '',
                    score: '',
                    classAvgScore: '',
                    gradeAvgScore: '',
                    areaAvgScore: '',
                    classRank: '',
                    gradeRank: '',
                    areaRank: '',
                };
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.subjects = this.$parentInfo.initInformation.subjects;
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.school_val.examSubjects.push(examSubject);
            },
            handleDeleteExam(index) {
                this.$parentInfo.schoolScore.dialog_AddSchoolScore.school_val.examSubjects.splice(index, 1);
            },
        }
    }
</script>

<style scoped lang="scss">
    .inputWidth {
        width: 180px !important;
    }
</style>
